import * as echarts from 'echarts';

const colors = [
  'rgb(153, 153, 153)',
  'rgba(223, 1, 1)',
  'rgba(4, 35, 51)',
  'rgba(0, 64, 255)',
  'rgba(4, 180, 49)',
  'rgba(215, 223, 1)',
  'rgba(138, 8, 104)',
];

let date = [];
let data = [Math.random() * 300];

export const opcoes = {
  color: colors,
  tooltip: {
    trigger: 'axis',
    position: function (pos, params, dom, rect, size) {
      const inicio = (pos[0] + size.contentSize[0]) > size.viewSize[0] ? (size.viewSize[0] - size.contentSize[0] - 50) : (pos[0]);
      const fim = '10%';
      return [inicio, fim];
    }
  },
  title: {
    left: 'center',
    text: ''
  },
  legend: {
    show: true,
  },
  toolbox: {
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      restore: {},
      saveAsImage: {}
    }
  },
  xAxis: {
    show: true,
    type: 'category',
    boundaryGap: false,
    axisLabel: {
      show: true,
      rotate: 60
    },
    data: date
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%'],
  },
  grid: {
    bottom: 210,
    left: 60,
    right: 40
  },
  dataZoom: [
    {
      type: 'slider',
      height: 100,
      moveHandleSize: 15,
      bottom: 30,
      backgroundColor: "rgba(0, 0, 0, 0.10)",
      borderColor: "rgba(0, 0, 0, 0.10)",
      dataBackground: {
        lineStyle: {
          color: "rgba(0, 13, 254, 1)"
        },
        areaStyle: {
          color: "rgba(32, 22, 215, 1)"
        }
      }
    },
  ],
  series: [
    {
      name: 'Fake Data',
      type: 'line',
      symbol: 'none',
      sampling: 'lttb',
      itemStyle: {
        color: 'rgb(255, 70, 131)'
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgb(255, 158, 68)'
          },
          {
            offset: 1,
            color: 'rgb(255, 70, 131)'
          }
        ])
      },
      data: data
    }
  ]
};
